import { GetterTree } from 'vuex'
import { ScriptEditState } from './state'
import { RootState } from '@/store/state'
import { ScriptCardContent, ScriptCardResponse } from '@/models/scripts'
import { CardVariant } from '@/constants/scripts'

export const getters: GetterTree<ScriptEditState, RootState> = {
  getScriptEditId(state): string | undefined {
    return state.scriptId
  },

  getScriptEditCardId(state): string | undefined {
    return state.cardId
  },

  getScriptEditInstanceId(state): string | undefined {
    return state.instanceId
  },

  getScriptEditCard(state): ScriptCardResponse | undefined {
    return !state.cardId ? undefined : state.cards[state.cardId]
  },

  getScriptEditCardNumber(state, getters): number | undefined {
    return getters.getScriptEditCard?.num
  },

  getScriptEditCardVariant(state): CardVariant {
    return state.variant
  },

  getScriptEditCardContent(state, getters): ScriptCardContent | undefined {
    const editCard = getters.getScriptEditCard

    return editCard?.content[getters.getScriptEditCardVariant]
  },
}
